import React, { useEffect, useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { FaEdit } from "react-icons/fa";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import PresentationModalContent from "./ModalContent/PresentationModalContent";
import {
  useAddEdPresentations,
  useGetBrandData,
  useGetLanguagesData,
  useGetPresentationTypeData,
  usePresentationData,
  useUpdateEdPresentations,
} from "./hooks/useEdetailing";
import { showToast } from "../../utils/toastUtils";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import axiosInstance from "../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { COLORS } from "../../constants/colors";

interface PresentationData {
  orgunit: string | number;
  id: number;
  brandid: string;
  brandName: string;
  presentationtype: string;
  presentationname: string;
  PageCount: any;
  presentationzipurl: string;
  mediaurl: string;
  presentationversionid: string | number;
  PresentationLanguageId: any;
  PresentationReleaseDate: any;
  PresentationMedia: any;
}

const presentationDataColumns = (
  handleUpdate: (row: PresentationData, Status: string) => void
) => {
  const columns = [
    {
      name: "Brand Name",
      maxWidth: "140px",
      canShow: true,
      selector: (row: PresentationData) => row.brandName,
      sortable: true,
    },
    {
      name: "Presentation Type",
      maxWidth: "180px",
      canShow: true,
      selector: (row: PresentationData) => row.presentationtype,
      sortable: true,
    },
    {
      name: "Presentation Name",
      maxWidth: "200px",
      canShow: true,
      selector: (row: PresentationData) => row.presentationname,
      sortable: true,
      wrap: true,
    },
    {
      name: "Presentation Zip URL",
      maxWidth: "300px",
      canShow: true,
      selector: (row: PresentationData) => row.presentationzipurl,
      sortable: true,
      wrap: true,
    },
    {
      name: "Version",
      maxWidth: "120px",
      canShow: true,
      selector: (row: PresentationData) => row.presentationversionid,
      sortable: true,
    },
    {
      name: "Page Count",
      maxWidth: "150px",
      canShow: false,
      selector: (row: PresentationData) => row.PageCount,
      sortable: true,
    },
    {
      name: "Languages",
      maxWidth: "150px",
      canShow: false,
      selector: (row: PresentationData) => row.PresentationLanguageId,
      sortable: true,
    },
    {
      name: "Presentation Release Date",
      maxWidth: "150px",
      canShow: false,
      selector: (row: PresentationData) => row.PresentationReleaseDate,
      sortable: true,
    },
    {
      name: "Presentation Media",
      maxWidth: "150px",
      canShow: false,
      selector: (row: PresentationData) => row.PresentationMedia,
      sortable: true,
    },

    {
      name: "Action",
      // width: "200px",
      canShow: true,
      cell: (row: any) => (
        <button
          onClick={() => handleUpdate(row, "Update")}
          className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
          style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
      ),
    },
  ];

  return columns?.filter((col) => col?.canShow);
};

const Presentation: React.FC = () => {
  const { startPolling, stopPolling } = useExcelPolling();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [chechStatusSubmitAndUpdate, setchechStatusSubmitAndUpdate] =
    useState<string>("");

  const [PresentationVersionId, setPresentationVersionId] = useState("1.0");
  // const [prevVersionId, setPrevVersionId] = useState("");
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");

  const [filtersState, setFiltersState] = useState<any>({
    limit: 10,
    page: 1,
    search: null,
  });
  const [selectedRow, setSelectedRow] = useState<PresentationData | null>(null);

  const toggleModal = (status: string) => {
    setchechStatusSubmitAndUpdate(status);
    setIsModalOpen(!isModalOpen);
    setSelectedRow(null);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setchechStatusSubmitAndUpdate("");
    setPresentationVersionId("1.0");
  };

  useEffect(() => {
    if (chechStatusSubmitAndUpdate === "Update") {
    }
  }, []);

  //  const handlePresentationVersion =()=>{

  //   if(chechStatusSubmitAndUpdate ==='Submit'){
  //       setPresentationVersionId('1.0');
  //   }

  //  }

  // API Hooks
  const { data: presentations } = usePresentationData({
    enable: true,
    params: {
      limit: filtersState.limit,
      page: filtersState.page,
      search: filtersState.search,
    },
  });


  const { data: brandData } = useGetBrandData({ enable: true });
  const { data: presentationTypeData } = useGetPresentationTypeData({
    enable: true,
  });
  const { data: languageData } = useGetLanguagesData({ enable: true });
  const { mutate: addEdPresentations } = useAddEdPresentations();
  const { mutate: updateEdPresentations } = useUpdateEdPresentations();
  const [selectedRowId, setSelectedRowId] = useState<number>();

  const handleUpdate = (row: any, status: string) => {
    console.log("🚀 ~ Presentation.tsx:183 ~ handleUpdate ~ row:", row);

    setPresentationVersionId(String(row.presentationversionid));
    setchechStatusSubmitAndUpdate(status);
    setSelectedRow(row);
    setIsModalOpen(true);
    setSelectedRowId(row.id);
  };

  const handleSubmit = (e: React.FormEvent, formData: any) => {
    e.preventDefault();
    console.log("Submitting Data:", formData);

    if (chechStatusSubmitAndUpdate === "Submit") {
      if (!formData.BrandId || Object.keys(formData.BrandId).length === 0) {
        showToast.warning("Please Select a Brand!");
        return;
      } else if (!formData.PresentationName.trim()) {
        showToast.warning("Please Fill the Presentation Field!");
        return;
      } else if (!formData.PresentationZipUrl.trim()) {
        showToast.warning("Please Fill the Presentation URL Field!");
        return;
      } else if (!formData.PresentationVersionId) {
        showToast.warning("Please Fill the Presentation Version Field!");
        return;
      } else if (!formData.PageCount) {
        showToast.warning("Please Fill the Page Count Field!");
        return;
      } else if (!formData.MediaUrl.trim()) {
        showToast.warning("Please Fill the Media URL Field!");
        return;
      } else if (!formData.PresentationReleaseDate) {
        showToast.warning("Please Fill the Presentation Release Date Field!");
        return;
      } else {
        const addFomData = {
          ...formData,
          BrandId: formData.BrandId.id || "", // ✅ Also fix for update
          // PresentationVersionId: newVersion,
        };
        addEdPresentations(addFomData, {
          onSuccess: () => {
            console.log("Presentation added successfully!");
            handleClose();
          },
          onError: (error) => {
            console.error("Error adding Presentation:", error);
          },
        });
      }
    } else {
      if (!formData.BrandId || Object.keys(formData.BrandId).length === 0) {
        showToast.warning("Please Select a Brand!");
        return;
      } else if (!formData.PresentationName.trim()) {
        showToast.warning("Please Fill the Presentation Field!");
        return;
      } else if (!formData.PresentationZipUrl.trim()) {
        showToast.warning("Please Fill the Presentation URL Field!");
        return;
      } else if (!formData.PresentationVersionId) {
        showToast.warning("Please Fill the Presentation Version Field!");
        return;
      } else if (!formData.PageCount) {
        showToast.warning("Please Fill the Page Count Field!");
        return;
      } else if (!formData.MediaUrl.trim()) {
        showToast.warning("Please Fill the Media URL Field!");
        return;
      } else if (!formData.PresentationReleaseDate) {
        showToast.warning("Please Fill the Presentation Release Date Field!");
        return;
      } else {
        const currentVersion = formData.PresentationVersionId || "1.0.";
        const [majorStr, minorStr] = currentVersion.split(".");
        let major = parseInt(majorStr);
        let minor = parseInt(minorStr);

        minor += 1;
        if (minor >= 10) {
          major += 1;
          minor = 0;
        }

        const newVersion = `${major}.${minor}`;
        const udpateFomData = {
          ...formData,
          BrandId: formData.BrandId.id || "", // ✅ Also fix for update
          PresentationVersionId: newVersion,
        };

        console.log(
          "🚀 ~ Presentation.tsx:249 ~ handleSubmit ~ udpateFomData:",
          udpateFomData
        );

        updateEdPresentations(
          { id: selectedRowId, body: udpateFomData },
          {
            onSuccess: () => {
              console.log("Ed Presentation updated successfully!");
              handleClose();
            },
            onError: (error) => {
              console.error("Error updating Ed Presentation:", error);
            },
          }
        );
      }
    }
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const presentationData = presentations?.data?.map((item: any) => ({
    orgunit: item?.OrgunitId,
    id: item.PresentationId,
    brandid: item.BrandId,
    brandName: item.Brands.BrandName,
    presentationtype: item.PresentationTypeName,
    presentationname: item.PresentationName,
    presentationzipurl: item.PresentationZipUrl,
    mediaurl: item.MediaUrl,
    presentationversionid: item.PresentationVersionId || [],
    PageCount: item.PageCount,
    PresentationLanguageId: item.PresentationLanguageId,
    PresentationReleaseDate: item.PresentationReleaseDate,
    PresentationMedia: item.PresentationMedia,
    PresentationTypeId: item.PresentationTypeId,
  }));

    const downloadExcelGet = async () => {
    const param: Record<string, any> = {
 
    };

    const queryString = new URLSearchParams(param).toString();
    try {
      setLoadingExcel(true);
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.EDETAILING.GET_EXCEL_ED_PESENTATION}?${queryString}`
      );
      const { success, fileDownloadId, intervalTime } =
        response?.data?.data || null;
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (currentStatus: string) => {
            setExcelStatus(currentStatus);
          },
          onSuccess: (url: any) => {
            setLoadingExcel(false);
            setExcelStatus('Loading..');
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },
          onFailed: (msg: any) =>{ 
            showToast.error(msg || "")
            stopPolling();
            setLoadingExcel(false);
          },
          onExpired: (msg: any) => {
            showToast.error(msg || "")
            stopPolling();
            setLoadingExcel(false);
          },
          onDeleted: (msg: any) => {
            showToast.error(msg || "")
            stopPolling();
            setLoadingExcel(false);
          }
        });
      }
    } catch (err: any) {
      showToast.error(err);
    }
  };

  return (
    <div className="p-2">
      <PageHeader
        title=" Presentation List"
        buttons={[
          {
            label: "+ Add EdPresentations",
            onClick: () => toggleModal("Submit"),
            color: "#2e8dd3",
          },
          {
            label: loadingExcel? excelStatus ? excelStatus.charAt(0).toUpperCase() + excelStatus.slice(1) +"..": "": "Excel",
            onClick: () =>downloadExcelGet(),
            color: loadingExcel ? COLORS.disable :"#43B9B2",
            disable: loadingExcel ? true : false,
          },
          // {
          //   label: "CSV",
          //   onClick: () => alert("Export CSV"),
          //   color: "#43B9B2",
          // },
        ]}
      />

      <BasicDataTable
        paginationTotalRows={presentations?.recordsTotal || 0}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        Title="Presentation List"
        data={presentationData}
        columns={presentationDataColumns(handleUpdate)}
      />

      <RouteModal
        isOpen={isModalOpen}
        toggle={handleClose}
        title={
          chechStatusSubmitAndUpdate === "Submit"
            ? "Add Presentation "
            : "Edit Presentation "
        }
        size="lg"
        content={
          <PresentationModalContent
            // handlePresentationVersion={handlePresentationVersion}
            PresentationVersionId={PresentationVersionId}
            setPresentationVersionId={setPresentationVersionId}
            handleSubmit={handleSubmit}
            handleClose={handleClose}
            brandData={brandData?.data}
            presentationTypeData={presentationTypeData?.data}
            languageData={languageData?.data}
            chechStatusSubmitAndUpdate={chechStatusSubmitAndUpdate}
            selectedRow={selectedRow}
          />
        }
      />
    </div>
  );
};

export default Presentation;
